var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 24,
  viewBox: "0 0 28 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.6243 23.489C11.0446 24.0686 10.1052 24.0686 9.52485 23.489L0.786512 14.7499C-0.262171 13.7013 -0.262171 12.0016 0.786512 10.9536C1.83452 9.90564 3.53481 9.90564 4.58213 10.9536L10.5749 16.945L23.417 0.786512C24.465 -0.262171 26.166 -0.262171 27.214 0.786512C28.262 1.83452 28.262 3.53481 27.214 4.58281L11.6243 23.489Z"
})));
export default SvgCheckRounded;